import { Button } from "../../../components/ui";
import useManageStatutoryComponents from "../../../hooks/companySettings/salaryStructure/useManageStatutoryComponents";

const StatutorySalaryComponents = () => {
  const {
    statutoryComponentsList,
    isFetchingStatutory,
    register,
    handleSubmit,
    updateStatutoryComponents,
  } = useManageStatutoryComponents();

  return (
    <>
      <p className="mb-5">
        Check the statutory salary components to apply them:
      </p>
      {isFetchingStatutory && (
        <p className="text-gray-500 py-10">Loading components...</p>
      )}
      <div className="space">
        {statutoryComponentsList.map((component) => {
          const { name, note, statutory_id } = component;
          return (
            <>
              <div className="flex items-center gap-3">
                <input
                  type="checkbox"
                  id={name + statutory_id}
                  {...register("statutory." + name)}
                />
                <label htmlFor={name + statutory_id}>{name}</label>
              </div>
              <p className="ml-6 mt-1 mb-6 text-sm text-gray-400">{note}</p>
            </>
          );
        })}
      </div>
      <div>
        <Button
          className="mt-5"
          onClick={handleSubmit(updateStatutoryComponents)}
        >
          Save Components
        </Button>
      </div>
    </>
  );
};

export default StatutorySalaryComponents;
